module.exports = __webpack_public_path__ + "img/img1v2.c1148dae.png";